<template>
<div>
      <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>
   
    <div v-if="displayContents('frontendRoute')">
    <v-toolbar flat color="white" pt-4 mt-4>
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="searchFrontend"></v-text-field>
        <v-btn round color="primary" @click="addFrontendRouteModal=true">
            Add Frontend Route
        </v-btn>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="frontendRoutes"
        :search="searchFrontend"
        :rows-per-page-items="[25, 50, 100, 250]"
        item-key="id"
        align-center
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon small @click="editFrontend(props.item)">edit</v-icon>
            <v-icon small @click="deleteFrontend(props.item)">delete</v-icon>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
           <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.urlExtension}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

      <v-dialog v-model="addFrontendRouteModal" max-width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD FRONTEND ROUTE</h1></v-toolbar>
              <v-card-text>
                  <v-text-field label="Route Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Url Extension" v-model="item.urlExtension"></v-text-field>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="addFrontendRouteModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveFrontendRoute">Save</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
      </div>
      <v-dialog v-model="editFrontendRouteModal" max-width="750px">
        <v-card flat color="white">
          <v-toolbar color="primary"><h1 class="headline white--text">EDIT FRONTEND ROUTE</h1></v-toolbar>
          <v-text-field v-model="item.name" label="Name"></v-text-field>
          <v-text-field v-model="item.urlExtension" label="URL"></v-text-field>
          <v-card-actions>
          <v-layout justify-center>
            <v-btn round colour="gluePrimary" @click="editFrontendRouteModal=false">Cancel</v-btn>
            <v-btn round colour="gluePrimary" @click="saveEditedFrontendRoute">Save</v-btn>
          </v-layout>
        </v-card-actions>

        </v-card>
        

      </v-dialog>

      <div v-if="displayContents('backendRoute')">
    <v-toolbar flat color="white" pt-4 mt-4>
      <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="searchBackend"></v-text-field>
        <v-btn round color="primary" @click="addBackendRouteModal=true">
            Add Backend Route
        </v-btn>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="backendRoutes"
        :search="searchBackend"
        item-key="id"
        :rows-per-page-items="[25, 50, 100, 250]"
        align-center
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon small @click="deleteBackend(props.item)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
           <td class="text-xs-center">{{props.item.urlExtension}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

      <v-dialog v-model="addBackendRouteModal" max-width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD BACKEND ROUTE</h1></v-toolbar>
              <v-card-text>
                  <v-text-field label="Route Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Url Extension" v-model="item.urlExtension"></v-text-field>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="addBackendRouteModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveBackendRoute">Save</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
      </div>

</div>
  
</template>

<script>
import Api from "@/services/Api";
export default {
    data(){
        return {
            addFrontendRouteModal:false,
            addBackendRouteModal: false,
            selected: [],
            editFrontendRouteModal: false,
            item: {},
            modules: [],
            frontendRoutes: [],
            backendRoutes: [],
            activeTabName: '',
            searchFrontend: '',
            searchBackend: '',
            tabs: [
        { name: "frontendRoute", displayName: "Frontend Routes" },
        { name: "backendRoute", displayName: "Backend Routes" }
      ],
            headers: [
                {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "URL Extension",
          align: "center",
          value: "urlExtension"
        }]
        }
    },
    created(){
        this.getFrontend();
        this.getBackend();
        this.setActiveTabName('frontendRoute')
    },
    methods: {
      editFrontend(item){
        this.item = Object.assign({}, item);
        this.editFrontendRouteModal=true
      },
        getFrontend(){
            Api()
            .get('/frontendRoute')
            .then(response=>{
                this.frontendRoutes=response.data
            })
        },
        getBackend(){
            Api()
            .get('/backendRoute')
            .then(response=>{
                this.backendRoutes=response.data
            })
        },
        deleteFrontend(item){
            Api()
            .put('/frontendRoute/'+item.id,{
                isActive: false,
                isDeleted: true
            }).then(this.getFrontend())
        },
        deleteBackend(item){
            Api()
            .put('/backendRoute/'+item.id,{
                isActive: false,
                isDeleted: true
            }).then(this.getBackend())
        },
        saveEditedFrontendRoute(){
          Api()
            .put('/frontendRoute/'+this.item.id,{
                name: this.item.name,
                urlExtension: this.item.urlExtension,
                isActive: true,
                isDelete: false
            }).then(this.editFrontendRouteModal=false, this.item={}, this.getFrontend())
        },
        saveFrontendRoute(){
            Api()
            .post('/frontendRoute',{
                name: this.item.name,
                urlExtension: this.item.urlExtension,
                isActive: true,
                isDelete: false
            }).then(this.addFrontendRouteModal=false, this.item={}, this.getFrontend())
        },
        saveBackendRoute(){
            Api()
            .post('/backendRoute',{
                name: this.item.name,
                urlExtension: this.item.urlExtension,
                isActive: true,
                isDelete: false
            }).then(this.addBackendRouteModal=false, this.item={}, this.getBackend())
        },
        routerLinkToDetails(item) {
      this.$router.push({ path: "/routeMapping/" + item.id });
  
    },
        displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    }

}
</script>

<style>

</style>